// @flow strict
import ReactGA from 'react-ga'

type dimensions = {
  dimension3?: string,
  dimension4?: string,
  dimension5?: string,
}
const setDimensionsFirePageview = (
  additionalDimensions: dimensions,
  pathname: string,
) => {
  ReactGA.set({
    dimension1: process.env.BRANCH,
    dimension2: process.env.COMMIT_REF,
    ...additionalDimensions,
  })
  ReactGA.pageview(pathname)
}

export default setDimensionsFirePageview
